import Vue from 'vue'
import utils from '@/utils/index.js'

Vue.directive('btnMask', {
    bind: function (el, binding, vnode) {
        function documentHandler(e) {
            // 这里判断点击的元素是否是本身，是本身，则返回
            if (el.contains(e.target)) {
                const oDiv = document.createElement('div')
                oDiv.innerHTML = ''
                oDiv.setAttribute('class', 'mask')
                el.parentNode.appendChild(oDiv)
                setTimeout(() => {
                    el && el.parentNode && el.parentNode.removeChild(oDiv)
                    // slow 3G下测试
                }, 4 * 1000)
                return false
            }
        }
        el.__vueClickOutside__ = documentHandler
        document.addEventListener('click', documentHandler)
    },
    unbind: function (el) {
        // 解除事件监听
        document.removeEventListener('click', el.__vueClickOutside__)
        delete el.__vueClickOutside__
    }
})

// 注册一个全局自定义指令 v-focus
Vue.directive('contentAnimate', {
    // 当绑定元素插入到 DOM 中。
    bind: function (el, binding, vnode) {
        const _vue = vnode.context
        const isFold = _vue.constractShow
        const needConstract = _vue.$route.meta.needConstract
        if (needConstract !== true) {
            _vue.setConstractStatus(false)
            return
        }
        utils.setFoldFlag(isFold)
        utils.setTranslate(isFold)
        window.addEventListener('resize', utils.setTranslate.bind(null, el))
    },

    update: function (el, binding, vnode) {
        const _vue = vnode.context
        const isFold = _vue.constractShow
        utils.setFoldFlag(isFold)
        utils.setTranslate(el)
    },

    unbind: function (el, binding, vnode) {
        const _vue = vnode.context
        _vue.setConstractStatus(false)
        window.removeEventListener('resize', utils.setTranslate)
    }
})

Vue.directive('fullScreen', {
    // 当绑定元素插入到 DOM 中。
    bind: function (el, binding, vnode) {
        const { value = {} } = binding
        const { mb = 30 } = value
        const _vue = vnode.context
        setTimeout(() => {
            fullInit(el, mb, _vue)
        }, 0)
    }
})

function fullInit(el, mb, _vue) {
    const _top = $(el).offset().top
    const _wHeight = window.innerHeight
    if (_vue && 'listTop' in _vue) {
        _vue.listTop = _top
    }
    let _height = 210
    if (_wHeight - _top - mb - 20 > _height) {
        _height = _wHeight - _top - mb - 20
    }
    $(el).css({
        'min-height': _height + 'px'
    })
}

function toggleInit(el, binding, init) {
    const { value = {} } = binding
    const { pdTop = 4, originHeight = 38 } = value
    const _this = $(el)
    const _child = _this.find('.content_wrapper')
    const more_btn = _this.find('.more_btn')
    const _childHeight = _child.innerHeight()
    if (_childHeight > 1.5 * originHeight) {
        more_btn.removeClass('no_more')
    } else {
        more_btn.addClass('no_more')

        _this.css({
            height: originHeight
        })
    }

    if (init) {
        more_btn.on('click', function () {
            if (!more_btn.hasClass('is_fold')) {
                more_btn.addClass('is_fold')
                const _child = _this.find('.content_wrapper')
                const _childHeight = _child.innerHeight()
                _this.css({
                    height: _childHeight + pdTop
                })
            } else {
                more_btn.removeClass('is_fold')
                _this.css({
                    height: originHeight
                })
            }
        })
    }
}

Vue.directive('toggleHeight', {
    // 当绑定元素插入到 DOM 中。
    bind: function (el, binding, vnode) {
        setTimeout(() => {
            toggleInit(el, binding, true)
        }, 0)
    },
    update: function (el, binding, vnode) {
        setTimeout(() => {
            const { value = {}, oldValue = {} } = binding
            const newList = value.list || []
            const oldList = oldValue.list || []
            const flag = utils.scalarArrayEquals(newList, oldList)
            if (newList.length <= 1) {
                const _this = $(el)
                const more_btn = _this.find('.more_btn')
                more_btn.removeClass('is_fold')
            }
            toggleInit(el, binding)
        }, 0)
    },

    unbind: function (el, binding, vnode) {
        const _this = $(el)
        const more_btn = _this.find('.more_btn')
        more_btn.off('click')
    }
})

Vue.directive('toBody', {
    // 当绑定元素插入到 DOM 中。
    bind: function (el) {
        setTimeout(() => {
            document.body.appendChild(el)
        }, 0)
    },
    unbind: function (el) {
        setTimeout(() => {
            if (el) {
                $(el).remove()
            }
        }, 0)
    }
})

Vue.directive('scrollLeft', {
    // 当绑定元素插入到 DOM 中。
    bind: function (el, vnode) {
        const setWidth = vnode.value && vnode.value.setWidth
        setTimeout(() => {
            const initLeft = $(document).scrollLeft()
            if (initLeft) {
                $(el).css({
                    transform: `translateX(-${initLeft}px)`
                })
            }
            $(document).on('scroll', function () {
                const left = $(document).scrollLeft()
                if (setWidth) {
                    $(el).css({
                        transform: `translateX(-${left}px)`,
                        width: `${$(document).width()}px`

                    })
                    $(window).resize(function () {
                        $(el).css({
                            transform: `translateX(-${left}px)`,
                            width: `${$(document).width()}px`

                        })
                    })
                } else {
                    $(el).css({
                        transform: `translateX(-${left}px)`

                    })
                }
            })
        }, 0)
    },
    unbind: function (el) {
        $(document).off('scroll')
    }
})

Vue.directive('expend', {
    // 当绑定元素插入到 DOM 中。
    bind: function (el, binding, vnode) {
        const _vue = vnode.context
        setTimeout(() => {
            if (el.scrollHeight > el.clientHeight) {
                _vue.needExpend = true
            }
        }, 0)
    }
})
Vue.directive('focus', {
    // 当绑定元素插入到 DOM 中。
    // 注册一个局部的自定义指令 v-focus

    // 指令的定义
    inserted: function (el) {
        // 聚焦元素
        el.querySelector('input').focus()
    }
})
Vue.directive('minWidth', {
    // 当绑定元素插入到 DOM 中。
    bind: function (el, binding, vnode) {
        const { value = {} } = binding
        const { clsName = 'w1080' } = value
        const _vue = vnode.context
        setTimeout(() => {
            $('html').addClass(clsName)
        }, 0)
    },
    unbind: function (el, binding, vnode) {
        const { value = {} } = binding
        const { clsName = 'w1080' } = value
        setTimeout(() => {
            $('html').removeClass(clsName)
        }, 0)
    }
})
